import React from 'react';
import { Button, Typography, Avatar } from '@mui/material';
import './UserInfo.css';
import { map, head } from 'lodash';
import { authenticateUriWithRedirectToFromQuery } from '../redirect-to';
import { useSession } from './SessionContext';

function initials(name) {
  const parts = name.split(/ /, 2);
  return map(parts, head).join('');
}

const UserInfo = () => {
  const { sessionInfo, logout: containerLogout } = useSession();

  function logout() {
    containerLogout().then(() => {
      window.location.href = authenticateUriWithRedirectToFromQuery();
    });
  }

  if (sessionInfo) {
    const { user } = sessionInfo;
    if (user) {
      return (
        <div className="SessionInfo">
          <Typography
            variant="body1"
            color="inherit"
            gutterBottom={false}
            title={user.name}
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            {user.emailAddress}
          </Typography>

          <Avatar sx={{ backgroundColor: '#ffc107', marginLeft: '24px', marginRight: '8px' }}>
            {initials(user.name)}
          </Avatar>

          <Button variant="contained" color="secondary" onClick={logout}>
            Logout
          </Button>
        </div>
      );
    }
  }

  return null;
};

export default UserInfo;
